<template>
  <div>
    <el-dialog
      title="抖音小程序营销券"
      :visible.sync="dialogVisible"
      :width="'1220px'"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closedFun"
    >
      <div class="dialog-alert">
        <strong>说明：</strong>
        <p>
          1、复访券可在特惠价格的基础上叠加使用。用户购票价=特惠价-优惠券面额。
        </p>
        <p>2、使用优惠券购票产生的优惠差额，将由您自己承担。</p>
        <p>
          3、佣金计算：用户使用复访券购票，平台先按平台折扣价作为用户支付价计算出您的原始佣金，再减去复访券金额，得出您最终的佣金。
        </p>
        <p class="dialog-alert_grey">
          例：市场价100元，平台折扣价90元(比市场价优惠10元)，用户使用20元优惠券购票(比市场价优惠20元)，则您的佣金=按平台折扣价90元计算得出的您的原始佣金
          - 复访券金额（20元）。
        </p>
      </div>
      <el-form
        label-width="120px"
        style="margin-top: 20px; width: 100%"
        :model="form"
        ref="formRef"
        :rules="rules"
        :disabled="isCheckLook"
      >
        <el-form-item label="优惠券名称" prop="name">
          <el-input v-model="form.name" style="width: 800px"></el-input>
        </el-form-item>
        <el-form-item
          label="可用影院"
          prop="cinemaStandardStr"
          class="cinemaStand-item"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="form.cinemaStandardStr"
            placement="top-start"
            popper-class="tool-tipgz"
          >
            <el-input
              v-model="form.cinemaStandardStr"
              placeholder="请筛选影院"
              disabled
              style="width: 400px"
            ></el-input>
          </el-tooltip>
          <span type="warning" class="cinemaStandBtn" @click="cinemaStandBtn"
            >筛选影院</span
          >
        </el-form-item>
        <el-form-item label="可发放期限" prop="grantTimeArr">
          <el-date-picker
            v-model="form.grantTimeArr"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="form.grantTimeArr"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeTimesValue"
          >
          </el-date-picker> -->
        </el-form-item>
        <el-form-item label="库存" prop="totalNum">
          <el-input v-model="form.totalNum" style="width: 200px">
            <template slot="append">张</template>
          </el-input>
        </el-form-item>
        <el-form-item label="优惠券类型" prop="type">
          <el-radio-group
            v-model="form.type"
            @change="changeRadio($event, 'a')"
          >
            <el-radio :label="1">满减券</el-radio>
            <el-radio :label="2">立减券</el-radio>
          </el-radio-group>
          <template v-if="form.type == 1">
            <div class="type-container">
              <el-form-item prop="minPayAmount">
                满
                <el-input
                  v-model="form.minPayAmount"
                  placeholder="请输入"
                  style="width: 200px"
                  ><template slot="append">元</template></el-input
                >
              </el-form-item>
              <el-form-item prop="discountAmount">
                减
                <el-input
                  v-model="form.discountAmount"
                  placeholder="请输入"
                  style="width: 200px"
                  ><template slot="append">元</template></el-input
                >
              </el-form-item>
            </div>
          </template>
          <template v-if="form.type == 2">
            <el-form-item prop="discountNow">
              立减金额：
              <el-input
                v-model="form.discountNow"
                placeholder="请输入"
                style="width: 120px"
              ></el-input>
              元
            </el-form-item>
          </template>
        </el-form-item>
        <el-form-item label="用户使用期限" prop="deadlineType">
          <el-radio-group
            v-model="form.deadlineType"
            @change="changeRadio($event, 'b')"
          >
            <el-radio :label="1">固定时间</el-radio>
            <el-radio :label="2">相对时间（领取后X天）</el-radio>
          </el-radio-group>
          <template v-if="form.deadlineType == 1">
            <el-form-item label="" prop="useTimeArr">
              <el-date-picker
                v-model="form.useTimeArr"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
              <!-- <el-date-picker
                v-model="form.useTimeArr"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker> -->
            </el-form-item>
          </template>
          <div v-if="form.deadlineType == 2">
            <el-form-item label="" prop="useDay">
              领取后
              <el-input v-model="form.useDay" style="width: 100px"> </el-input>
              天可用
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="使用条件" prop="useCondition">
          <el-input
            v-model="form.useCondition"
            style="width: 800px"
            placeholder="50个字以内"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="领取须知">
          <el-input
            v-model="form.notice"
            type="textarea"
            style="width: 800px"
            placeholder="非必填，50个字以内"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <!-- <el-switch
            v-model="form.status"
            active-color="#ff8622"
            :active-value="10"
            :inactive-value="20"
          >
          </el-switch> -->
          <span class="status-text">默认开启</span>
        </el-form-item>
      </el-form>
      <div class="btns-coantainer">
        <el-button :loading="submitLoading" type="warning" @click="submit" v-if="!isCheckLook"
          >确认</el-button
        >
        <el-button type="warning" plain @click="onCancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 筛选影院 -->
    <filter-cinema
      v-if="cinemaVisible"
      v-model="cinemaVisible"
      @selectCinema="selectCinema"
      :ids="form.cinemaClassifyId"
      :types="form.cinemaFilterType"
      :isDisable="isCheckLook"
      @close="cinemaVisible = false"
    />
  </div>
</template>

<script>
import filterCinema from "@/components/FilterCinema.vue";
import {deepClone} from '@/utils/tool.js'
import mini from "@/api/mini";
const MiniModel = new mini();
let defaultForm = {
  name: "",

  cinemaStandardStr: "全部影院",
  cinemaClassifyId:[], //选中的影院
  cinemaFilterType: 0, //0:全部影院 1:指定影院分类

  grantTimeArr: "", //可发放时间
  totalNum: "", //库存
  type: 1, //优惠券类型，1满减券，2立减金
  minPayAmount: "", //满
  discountAmount: "", //减
  discountNow: "", //立减金

  deadlineType: 1, // 用户使用期限，1固定时间，2相对时间
  useTimeArr: "", //固定时间日期
  useDay: "", //领取后几天内可用

  useCondition: "", //使用条件
  notice: "", //领取须知
  status: 10, //开关状态，默认开启
}
export default {
  components:{filterCinema},
  data() {
    return {
      isCheckLook:false,
      dialogVisible: false,
      submitLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入优惠券名称",
            trigger: ["blur", "change"],
          },
        ],
        grantTimeArr: [
          {
            required: true,
            message: "请选择可发放时间日期",
            trigger: ["blur", "change"],
          },
        ],
        totalNum: [
          {
            required: true,
            message: "请输入库存",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
          },
        ],
        type: [
          {
            required: true,
            message: "请选择优惠券类型",
            trigger: ["blur", "change"],
          }
        ],
        minPayAmount: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
          },
        ],
        discountAmount: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
          },
        ],
        discountNow: [
          {
            required: true,
            message: "请输入立减金额",
            trigger: ["blur", "change"],
          },
        ],
        deadlineType: [
          {
            required: true,
            message: "请选择用户使用期限",
            trigger: ["blur", "change"],
          },
        ],
        useTimeArr: [
          {
            required: true,
            message: "请选择固定时间日期",
            trigger: ["blur", "change"],
          },
        ],
        useDay: [
          {
            required: true,
            message: "请输入天数",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
          },
        ],
        useCondition: [
          {
            required: true,
            message: "请输入使用条件",
            trigger: ["blur", "change"],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择启用状态",
            trigger: ["blur", "change"],
          },
        ],
      },
      form: {
        // name: "",

        // cinemaStandardStr: "全部影院",
        // cinemaClassifyId:[], //选中的影院
        // cinemaFilterType: 0, //0:全部影院 1:指定影院分类

        // grantTimeArr: [], //可发放时间
        // totalNum: "", //库存
        // type: 1, //优惠券类型，1满减券，2立减金
        // minPayAmount: "", //满
        // discountAmount: "", //减
        // discountNow: "", //立减金

        // deadlineType: 1, // 用户使用期限，1固定时间，2相对时间
        // useTimeArr: [], //固定时间日期
        // useDay: "", //领取后几天内可用

        // useCondition: "", //使用条件
        // notice: "", //领取须知
        // status: 1, //开关状态，默认开启
      },
      cinemaVisible: false, // 筛选影院
    };
  },
  methods: {
    submit() {
      console.log(this.form, "form");
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let params=deepClone(this.form)
          // 可发放时间
          params.grantTimeBegin = params.grantTimeArr[0]
          params.grantTimeEnd = params.grantTimeArr[1]
          //
          if(params.type == 1) {
            params.minPayAmount = Math.ceil(Math.round((params.minPayAmount) * 100))
            params.discountAmount = Math.ceil(Math.round((params.discountAmount) * 100))
          }else if(params.type == 2) {
            // 立减金
            params.discountAmount = Math.ceil(Math.round((params.discountNow) * 100))
            delete params.discountNow
          }
          // 用户使用期限
          if(params.deadlineType == 1) {
            params.useTimeBegin = params.useTimeArr[0]
            params.useTimeEnd = params.useTimeArr[1]
          }else if(params.deadlineType == 2) {

          }
          if(params.cinemaFilterType == 1) {
            // 可用影院分类Id英文逗号分隔
            params.cinemaClassifyId = params.cinemaClassifyId.join(',')
            // 可用影院分类 名称
            params.cinemaClassifyName = params.cinemaStandardStr
            delete params.cinemaStandardStr
          }else if(params.cinemaFilterType == 0) {
            params.cinemaClassifyId = ''
            params.cinemaClassifyName = ''
            delete params.cinemaStandardStr
          }

          console.log(this.form,"通过=",params);
          // return
          this.submitLoading = true
          MiniModel.dyCouponSave(params).then(res => {
            console.log(res,'创建新优惠券')
            if(res.data.code == 200) {
              this.$message.success(res.data.message);
              this.$emit('updateDy')
              this.dialogVisible = false
            }
          }).finally(()=>{
            this.submitLoading = false
          })
        } else {
          console.log("error submit!!");
        }
      });
    },
    // 选中部分,子传父
    selectCinema(arr,type) {
      console.log(arr,type,'点击确定==子传父')
      this.form.cinemaFilterType = type
      this.form.cinemaClassifyId = arr.map((item) => item.id);
      console.log( this.form.cinemaClassifyId ,' this.form.cinemaClassifyId ')
      if(type) {
        this.form.cinemaStandardStr = arr
        .map((item) => item.name)
        .join(",");
      }else{
        this.form.cinemaStandardStr = '全部影院'
      }
      console.log(this.form.cinemaStandardStr,'this.form.cinemaStandardStr')
    },
    onCancel() {
      this.closeReset();
    },
    open(row) {
      console.log(row,'openopen==')
      this.dialogVisible = true;
      if(row) {
        console.log('查看11')
        // this.dialogVisible = true;
        // 查看
        this.isCheckLook = true
        if(row) {
          this.form.name = row.name
          this.form.cinemaClassifyId = row.cinemaClassifyId.split(',')
          this.form.cinemaFilterType = row.cinemaFilterType
          if(row.cinemaFilterType) {
            this.form.cinemaStandardStr = row.cinemaClassifyName
          }else{
            this.form.cinemaStandardStr = "全部影院"
          }
          this.form.grantTimeArr = [row.grantTimeBegin,row.grantTimeEnd]
          this.form.totalNum = row.totalNum
          this.form.type = row.type
          if(row.type == 1) {
            this.form.minPayAmount = row.minPayAmount / 100
            this.form.discountAmount = row.discountAmount / 100
          }else{
            this.form.discountNow = row.discountAmount / 100
          }
          if(row.useDay > 0) {
            this.form.deadlineType = 2
            this.form.useDay = row.useDay
          }else{
            this.form.deadlineType = 1
            this.form.useTimeArr = [row.useTimeBegin,row.useTimeEnd]
            // this.$nextTick(()=>{
            //   this.form.useTimeArr = [row.useTimeBegin,row.useTimeEnd]
            // })
          }
          this.form.useCondition = row.useCondition
          this.form.notice = row.notice

        }
      }else{
        console.log('编辑11')
        this.isCheckLook = false
        this.form = Object.assign({},defaultForm)
      }
      console.log(this.form,'form=open===1')
      this.dialogVisible = true;
      this.$nextTick(()=> {
        this.$refs.formRef.clearValidate();
      })
    },
    handleClose() {
      console.log("右上角取消==1");
      this.closeReset();
    },
    closedFun() {
      console.log("关闭了");
    },
    closeReset() {
      this.dialogVisible = false;
    },
    cinemaStandBtn() {
      this.cinemaVisible = true;
    },
    changeTimesValue(e) {
      console.log(e, "可发放时间");
    },
    changeRadio(e, type) {
      console.log(e, type, "event");
      if (type == "a") {
        console.log("切换优惠券类型");
        // 优惠券类型
        if (e == 1) {
          this.form.discountNow = "";
        } else if (e == 2) {
          this.form.minPayAmount = "";
          this.form.discountAmount = "";
        }
      } else if (type == "b") {
        console.log("切换用户使用期限");
        // 用户使用期限
        if (e == 1) {
          this.form.useDay = "";
        } else if (e == 2) {
          this.form.useTimeArr = [];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.btns-coantainer {
  margin: 30px 0 20px 120px;
}
.dialog-alert {
  display: block;
  padding: 10px;
  color: #666;
  background: #efefef;
  strong {
    display: block;
    color: #333;
  }
  p {
    display: block;
  }
  &_grey {
    color: #999;
  }
}
.cinemaStandBtn {
  margin-left: 20px;
  cursor: pointer;
  color: #ff8622;
  text-decoration: underline;
}
.type-container {
  display: flex;
  width: 450px;
  justify-content: space-between;
}
.status-text {
  color: #999;
  margin-left: 10px;
  font-size: 12px;
}
/deep/.el-range-separator {
  width: 10% !important;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #333 !important;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #ff8622 !important;
  border-color: #ff8622 !important;
}
/deep/.el-date-editor, .el-dialog__wrapper .el-date-editor{
  width: 400px !important;
}
</style>
<style>
.tool-tipgz {
  max-width: 600px;
}
.el-tooltip__popper {
  max-width: 60% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDy/createCoupon.vue